"use client";
import React, { Fragment, useEffect, useState } from "react";
import Icon from "@/components/ui/Icon";
import { Tab, Disclosure, Transition } from "@headlessui/react";
import { motion, useInView } from "framer-motion";
import { useRouter } from "next/navigation";
import Card from "../ui/Card";
import ApplyForm from "./ApplyForm";
import { AjaxGet, AjaxGetAnon, AjaxPost } from "@/util/Ajax";
import Button from "../ui/Button";
import useAuthInfo from "@/store/auth";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Swal from "sweetalert2";

const buttons = [
  {
    title: "Eyam Loan",
    icon: "heroicons-outline:home",
  },
  {
    title: "Bridging Finance – Property Seller",
    icon: "heroicons-outline:home",
  },
  {
    title: "Bridging Finance – Estate Agent",
    icon: "heroicons-outline:user",
  },
  {
    title: "Bridging Finance – Paid Up Fixed Property",
    icon: "heroicons-outline:home",
  },
  // {
  //   title: "Bridging Finance – Tender/Contract Financing",
  //   icon: "heroicons-outline:clipboard-document-check",
  // },
];
const TabAccrodain = () => {
  const router = useRouter();
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const userData = useAuthInfo((state) => state);
  const [walletAmount, setWalletAmount] = useState(0);
  const [borrowAmount, setBorrowAmount] = useState(200);
  const [isWalletDataLoading, setIsWalletDataLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmittingRequest, setIsSubmittingRequest] = useState(false);

  const GetDocuments = async () => {
    var res = await AjaxGetAnon("GetAll/Document");
    if (res.data) {
      setDocuments(res.data);
    }
    setIsLoading(false);
  };

  const getCurrentWalletData = async () => {
    setIsWalletDataLoading(true);
    var res = await AjaxGet(userData, `Portfolio/Data`);
    if (res.data) {
      setWalletAmount(res.data.suppliedAmount - res.data.borrowedAmount);
    }
    setIsWalletDataLoading(false);
  };

  const applyForEyamLoan = async () => {
    setIsSubmittingRequest(true);
    var res = await AjaxPost(userData, `Apply/Borrow`, {
      amount: borrowAmount,
      itemTypeId: 5,
      months: 1,
      documents: [],
    });
    if(res?.response?.data?.message){
      Swal.fire({
        title: "Error",
        text: res.response.data.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
      setIsModalOpen(false);
      setIsSubmittingRequest(false);
      return;
    }
    if (res.data) {
      Swal.fire({
        title: "Success",
        text: "Your Application has been submitted",
        icon: "success",
        confirmButtonText: "Ok",
      })
      router.push("/portfolio");
    }
    setIsSubmittingRequest(false);
  };

  useEffect(() => {
    if (userData.apiToken) {
      getCurrentWalletData();
    }
    GetDocuments();
  }, []);

  return (
    <div id="Types">
      <div className="mt-4 md:mb-16 mb-8">
        <motion.h2
          initial={{ opacity: 0, translateY: -50 }}
          whileInView={{ opacity: 100, translateY: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="text-center mb-4"
        >
          Explore our range of loans
        </motion.h2>
        {/* <div className="flex justify-center items-center">
          <motion.p
            initial={{ opacity: 0, translateY: -50 }}
            whileInView={{ opacity: 100, translateY: 0 }}
            transition={{ duration: 0.3, delay: 0.2 }}
            className="text-lg font-medium md:mt-5 text-center max-w-screen-md"
          >
            Explore our range of loan types tailored to meet various business
            needs. Click on a loan type to view the requirements and application
            form.
          </motion.p>
        </div> */}
      </div>
      <motion.div
        initial={{ opacity: 0, translateX: -50 }}
        whileInView={{ opacity: 100, translateX: 0 }}
        transition={{ duration: 0.3, delay: 0.1 }}
        className=""
      >
        <Tab.Group>
          <div className="grid grid-cols-12 md:gap-2">
            <div className="lg:col-span-3 md:col-span-5 col-span-12">
              <Tab.List className={"sticky top-32"}>
                <Card className="shadow-md bg-gray-50">
                  {buttons.map((item, i) => (
                    <Tab as={Fragment} key={i}>
                      {({ selected }) => (
                        <button
                          onClick={() => {}} //router.push("/funding#Types")}
                          className={`flex items-center text-left font-medium mb-7 capitalize  dark:bg-slate-800 ring-0 foucs:ring-0 focus:outline-none px-2 transition duration-150 before:transition-all before:duration-150 relative before:absolute
                     before:left-1/2 before:bottom-[-6px] before:h-[1.5px] 
                      before:bg-primary-500 before:-translate-x-1/2
              
              ${
                selected
                  ? "text-primary-500 before:w-full"
                  : "text-slate-500 before:w-0 dark:text-slate-300"
              }
              `}
                        >
                          <span className="text-base relative top-[1px] ltr:mr-1 rtl:ml-1">
                            <Icon icon={item.icon} />
                          </span>
                          {item.title}
                        </button>
                      )}
                    </Tab>
                  ))}
                </Card>
              </Tab.List>
            </div>
            <div className="lg:col-span-9 md:col-span-7 col-span-12 mb-8">
              <Tab.Panels>
                <Card className="shadow-md bg-gray-50">
                  <Tab.Panel>
                    <motion.div
                      initial={{ opacity: 0, translateX: 0 }}
                      whileInView={{ opacity: 100, translateX: 0 }}
                      transition={{ duration: 0.3, delay: 0.1 }}
                      className="flex justify-center items-center flex-col"
                    >
                      <h2 className="text-center">
                        Borrow up to 40% of Your Contributed Supply
                      </h2>
                      <p className="mt-4">
                        Eyam Loans are designed exclusively for contributors to
                        our liquidity funding pool. This unique loan option
                        allows you to access up to <strong>40%</strong> of your
                        contributed supply value, providing you with financial
                        flexibility while keeping your investments intact. No
                        document uploads are required to qualify—simply ensure
                        you’ve contributed to our pool and get access to funds
                        when you need them most.
                      </p>
                      <h3 className="text-center my-8">
                        No Documents are required
                      </h3>
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0, translateX: 0 }}
                      whileInView={{ opacity: 100, translateX: 0 }}
                      transition={{ duration: 0.3, delay: 0.1 }}
                      className="mt-4"
                    >
                      {!userData.apiToken && (
                        <Button
                          icon="heroicons-outline:banknotes"
                          onClick={() => {
                            router.push("/register");
                          }}
                          className="bg-primary-500 text-white w-full mt-4"
                        >
                          Borrow Today
                        </Button>
                      )}
                      {userData.apiToken && (
                        <Dialog
                          onOpenChange={setIsModalOpen}
                          modal
                          open={isModalOpen}
                        >
                          <Button
                            icon="heroicons-outline:banknotes"
                            onClick={() => {
                              setIsModalOpen(true);
                            }}
                            className="bg-primary-500 text-white w-full mt-4"
                          >
                            Borrow Today
                          </Button>
                          <DialogContent className="sm:max-w-md">
                            <DialogHeader>
                              <DialogTitle>Get an Eyam Loan</DialogTitle>
                              <DialogDescription>
                                You can borrow up to 40% of your Wallet amount
                              </DialogDescription>
                            </DialogHeader>
                            <div className="flex items-center space-x-2">
                              <div className="grid flex-1 gap-2">
                                <h3 className="text-center">Wallet Balance</h3>
                                <p className="text-center">
                                  R {walletAmount.toFixed(2)}
                                </p>
                                <Label htmlFor="borrowAmount">
                                  Total Amount R
                                </Label>
                                <Input
                                  type="number"
                                  id="borrowAmount"
                                  value={borrowAmount}
                                  className={`w-full ${
                                    borrowAmount > walletAmount * 0.4
                                      ? "border-red-500"
                                      : " mb-8"
                                  }`}
                                  onChange={(e) => {
                                    setBorrowAmount(e.target.value);
                                  }}
                                  max={(walletAmount * 0.4).toFixed(2)}
                                  placeholder="Enter Amount"
                                />
                                {borrowAmount > walletAmount * 0.4 && (
                                  <p className="text-danger-500">
                                    You can only Borrow Up to{" "}
                                    <strong>
                                      R{(walletAmount * 0.4).toFixed(2)}
                                    </strong>
                                  </p>
                                )}
                                <div className="flex flex-row ">
                                  <p>Admin Fee 5%</p>
                                  <p className="ml-auto">R {(borrowAmount *0.05).toFixed(2)}</p>
                                </div>
                                <div className="flex flex-row ">
                                  <p className="font-bold">Amount You Recieve</p>
                                  <p className="ml-auto font-bold">R {(borrowAmount *0.95).toFixed(2)}</p>
                                </div>
                              </div>
                            </div>
                            <DialogFooter className="sm:justify-start">
                              <Button
                                onClick={() => {
                                  setIsModalOpen(false);
                                }}
                                type="button"
                                className="bg-gray-200 text-gray-800 w-full mt-4"
                                disabled={isSubmittingRequest}
                              >
                                Close
                              </Button>

                              <Button
                                icon="heroicons-outline:banknotes"
                                onClick={() => {
                                  if(!((borrowAmount > walletAmount * 0.4) || borrowAmount < 200)){
                                    applyForEyamLoan();
                                  }else{

                                  }
                                }}
                                disabled={
                                  ((borrowAmount > walletAmount * 0.4) || borrowAmount < 200) ||
                                  isSubmittingRequest 
                                }
                                isLoading={isSubmittingRequest}
                                className="bg-primary-500 text-white w-full mt-4"
                              >
                                Borrow
                              </Button>
                            </DialogFooter>
                          </DialogContent>
                        </Dialog>
                      )}
                    </motion.div>
                  </Tab.Panel>
                  <Tab.Panel>
                    <motion.div
                      initial={{ opacity: 0, translateX: 0 }}
                      whileInView={{ opacity: 100, translateX: 0 }}
                      transition={{ duration: 0.3, delay: 0.1 }}
                      className="flex justify-center items-center flex-col"
                    >
                      <h2 className="text-center">
                        Have you sold your property ? Awaiting funds upon
                        registration?
                      </h2>
                      <ApplyForm
                        documents={documents.filter((x) => x.id == 1)}
                        itemTypeId={1}
                      />
                    </motion.div>
                  </Tab.Panel>
                  <Tab.Panel>
                    <motion.div
                      initial={{ opacity: 0, translateX: 0 }}
                      whileInView={{ opacity: 100, translateX: 0 }}
                      transition={{ duration: 0.3, delay: 0.1 }}
                      className="flex justify-center items-center flex-col"
                    >
                      <h2 className="text-center">
                        Sold a property? Due commission on registration?
                      </h2>
                      <ApplyForm
                        documents={documents.filter((x) => x.id == 2)}
                        itemTypeId={2}
                      />
                    </motion.div>
                  </Tab.Panel>
                  <Tab.Panel>
                    <motion.div
                      initial={{ opacity: 0, translateX: 0 }}
                      whileInView={{ opacity: 100, translateX: 0 }}
                      transition={{ duration: 0.3, delay: 0.1 }}
                      className="flex justify-center  flex-col"
                    >
                      <h2 className="text-center">
                        Own a fully paid-up, unencumbered fixed property?
                      </h2>

                      <ApplyForm
                        documents={documents.filter((x) => x.id == 3)}
                        itemTypeId={3}
                      />
                    </motion.div>
                  </Tab.Panel>
                  <Tab.Panel>
                    <motion.div
                      initial={{ opacity: 0, translateX: 0 }}
                      whileInView={{ opacity: 100, translateX: 0 }}
                      transition={{ duration: 0.3, delay: 0.1 }}
                      className="flex justify-center items-center flex-col"
                    >
                      <h2 className="text-center">
                        Eyam connects you with Lenders who can provide working
                        capital for approved tenders and contracts.
                      </h2>

                      <ApplyForm
                        documents={documents.filter((x) => x.id == 4)}
                        itemTypeId={4}
                      />
                    </motion.div>
                  </Tab.Panel>
                </Card>
              </Tab.Panels>
            </div>
          </div>
        </Tab.Group>
      </motion.div>
    </div>
  );
};

export default TabAccrodain;
